import type { GetCustomersOverviewsNewResponse } from '@vy/api-definition';
import { vySerialize } from '@vy/utils';
import type { UseQueryOptions } from 'react-query';
import { useTableDataFromParams } from '../../../hooks/use-table-data-from-params';
import { useFiltersParam } from '../../../pages/customers/CustomersPage/customers-page-hooks/use-filters-param';
import { useQueryInputParams } from '../../../pages/customers/CustomersPage/customers-page-hooks/use-query-input-param';
import { useCustomersOverviewsNew } from './use-customers-overviews-new';

export function useCustomersOverviewsFromParamsNew(
  options?: UseQueryOptions<GetCustomersOverviewsNewResponse>,
) {
  const [search] = useQueryInputParams();
  const [filters] = useFiltersParam();
  const { page, pageSize, onPageChange, onPageSizeChange, sort } = useTableDataFromParams();

  const filtersForApi = filters?.map((filter) => {
    const { id: _id, ...rest } = filter as typeof filter & { id?: string };
    return rest;
  });

  const payload = {
    search: search ?? undefined,
    customerFilters: vySerialize(filtersForApi),
    page,
    pageSize,
    sort,
  };

  const queryResult = useCustomersOverviewsNew(payload, {
    keepPreviousData: true,
    ...options,
  });

  return {
    ...queryResult,
    page,
    pageSize,
    onPageChange,
    onPageSizeChange,
  };
}
